import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 8.002c-4.551 0-8.92 1.791-12.16 4.985a1 1 0 1 1-1.404-1.424 19.325 19.325 0 0 1 27.128 0 1 1 0 0 1-1.404 1.424A17.33 17.33 0 0 0 16 8.002"
    />
    <path
      fill="currentColor"
      d="M8.073 17.228a11.35 11.35 0 0 1 15.854 0 1 1 0 0 0 1.396-1.431 13.35 13.35 0 0 0-18.646 0 1 1 0 0 0 1.396 1.431"
    />
    <path
      fill="currentColor"
      d="M12.305 21.484a5.337 5.337 0 0 1 7.39 0 1 1 0 0 0 1.385-1.443 7.34 7.34 0 0 0-10.16 0 1 1 0 0 0 1.385 1.443M17.5 25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
  </svg>
);
const SvgIconWifiHigh = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWifiHigh);
export default Memo;
